import { MESSENGER_FORM_FIELDS } from "./messengerIntegrationForm";

const PHOREST_FORM_FIELDS = [
  "integrationsPhorestEnabled",
  "integrationsPhorestRegion",
  "integrationsPhorestBusinessId",
  "integrationsPhorestBranchId",
  "integrationsPhorestCurrency",
  "integrationsPhorestApiUsername",
  "integrationsPhorestApiPassword",
  "integrationsPhorestApiPasswordConfigured",
];

export const getPhorestDraftValues = (values) =>
  Object.fromEntries(
    PHOREST_FORM_FIELDS.map((fieldName) => [fieldName, values?.[fieldName]])
  );

const normalizeText = (value) =>
  typeof value === "string" ? value.trim() : "";

const normalizePassword = (value) =>
  typeof value === "string" ? value : "";

export const getPhorestFormValues = (integration) => ({
  integrationsPhorestEnabled: integration?.enabled === true,
  integrationsPhorestRegion:
    normalizeText(integration?.config?.region).toUpperCase() || "EU",
  integrationsPhorestBusinessId: normalizeText(integration?.config?.businessId),
  integrationsPhorestBranchId: normalizeText(integration?.config?.branchId),
  integrationsPhorestCurrency:
    normalizeText(integration?.config?.currency).toUpperCase() || "EUR",
  integrationsPhorestApiUsername: normalizeText(integration?.config?.apiUsername),
  integrationsPhorestApiPassword: "",
  integrationsPhorestApiPasswordConfigured:
    integration?.config?.apiPasswordConfigured === true,
});

const getPhorestFingerprint = (values) =>
  JSON.stringify({
    enabled: values?.integrationsPhorestEnabled === true,
    region: normalizeText(values?.integrationsPhorestRegion).toUpperCase(),
    businessId: normalizeText(values?.integrationsPhorestBusinessId),
    branchId: normalizeText(values?.integrationsPhorestBranchId),
    currency: normalizeText(values?.integrationsPhorestCurrency).toUpperCase(),
    apiUsername: normalizeText(values?.integrationsPhorestApiUsername),
    apiPassword: normalizePassword(values?.integrationsPhorestApiPassword),
  });

export const hasPhorestIntegrationChanges = (values, integration) =>
  getPhorestFingerprint(values) !==
  getPhorestFingerprint(getPhorestFormValues(integration));

export const buildPhorestIntegrationPayload = (values) => {
  const enabled = values?.integrationsPhorestEnabled === true;
  const payload = {
    type: "phorest",
    enabled,
    configVersion: 1,
    config: {},
  };

  if (!enabled) {
    return payload;
  }

  payload.config = {
    region: normalizeText(values.integrationsPhorestRegion).toUpperCase(),
    businessId: normalizeText(values.integrationsPhorestBusinessId),
    branchId: normalizeText(values.integrationsPhorestBranchId),
    currency: normalizeText(values.integrationsPhorestCurrency).toUpperCase(),
    apiUsername: normalizeText(values.integrationsPhorestApiUsername),
  };

  const password = normalizePassword(values.integrationsPhorestApiPassword);
  if (password.trim()) {
    payload.config.apiPassword = password;
  }

  return payload;
};

export const getBusinessFormFingerprint = (values) =>
  JSON.stringify(
    Object.fromEntries(
      Object.entries(values || {}).filter(
        ([fieldName]) =>
          !PHOREST_FORM_FIELDS.includes(fieldName) &&
          !MESSENGER_FORM_FIELDS.includes(fieldName)
      )
    )
  );
